// Stripe checkout utilities for web and mobile
import { loadStripe } from '@stripe/stripe-js';
import { request } from '@/api/request';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY); // Stripe Public Key

// Web version - redirects automatically
export const handleTopUp = async (
  amount: number,
  clientId: string,
  reference?: string
): Promise<void> => {
  try {
    const data = await request<{ success: boolean; sessionId: string }>(
      '/create-checkout-session',
      {
        method: 'POST',
        body: JSON.stringify({ amount, clientId, reference }),
      }
    );

    if (!data?.success || !data.sessionId) {
      console.error(
        'Session ID not found in response:',
        data
      );
      throw new Error('Failed to create checkout session.');
    }

    const { sessionId } = data;
    const stripe = await stripePromise;
    if (stripe) {
      const { error: redirectError } = await stripe.redirectToCheckout({
        sessionId,
      });
      if (redirectError) {
        console.error('Stripe redirect error:', redirectError);
        throw redirectError;
      }
    } else {
      console.error('Stripe.js has not loaded yet.');
      throw new Error('Stripe.js failed to load');
    }
  } catch (e) {
    console.error('Error in handleTopUp:', e);
    throw e; // Re-throw for calling component to handle
  }
};
